function initVerticalCarousel() {
    // Init scroll controller
    let controller = new ScrollMagic.Controller();

    // Initialize vertical slider scroll for each vertical slider
    document.querySelectorAll('.vertical-slider-item').forEach(function (sliderItem) {
        let pillElement = sliderItem.querySelector('.pill'),
            lineElement = sliderItem.querySelector('.line'),
            verticalCarouselContainer = sliderItem.closest('.vertical-carousel-container'),
            imageElement = verticalCarouselContainer.querySelector('#image-' + sliderItem.id);

        lineElement.style.maxHeight = getComputedStyle(sliderItem).height;

        new ScrollMagic.Scene({triggerElement: pillElement})
            .setClassToggle(sliderItem, 'active')
            .addTo(controller);

        new ScrollMagic.Scene({triggerElement: pillElement})
            .on('enter leave', function (e) {
                if(e.type === 'enter') {
                    imageElement.classList.add('active');
                } else {
                    if(imageElement.dataset.index !== '0') {
                        imageElement.classList.remove('active');
                    }
                }
            })
            .addTo(controller);
    });

    setCarouselLineHeight();

    window.onresize = function() {
        setCarouselLineHeight();
    }
}

function setCarouselLineHeight() {
    document.querySelectorAll('.vertical-slider-item').forEach(function (sliderItem) {
        let lineElement = sliderItem.querySelector('.line');
        lineElement.style.maxHeight = getComputedStyle(sliderItem).height;
    });
}

initVerticalCarousel();
